module.exports = __webpack_public_path__ + "img/loading.5605dd83.svg";